import dayjs from "dayjs";
import MiniInfoCard from "@lib/components/MiniComponents/Dashboard/MiniInfoCard";
import { magenta } from "@ant-design/colors";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiGetCustomerLeadScannedTransaction } from "@lib/api/walletSendByte";
import { TbZoomMoney } from "react-icons/tb";
import { useTypedSelector } from "@lib/redux";
import { ROUTES } from "@lib/constants";
import { AppCardProps } from "@lib/components/AppComponents/AppCard";

type Props = {
  cardProps?: AppCardProps;
};

export default function LeadBlockchainPaymentsMiniCard(props: Props) {
  const { cardProps } = props;
  const { messages } = useIntl();
  const navigate = useNavigate();
  const { selectedCustomer } = useTypedSelector((state) => state.cache);

  const initialFilters = [
    ...(selectedCustomer
      ? [`customerUser.customerId||$eq||${selectedCustomer.id}`]
      : []),
  ];

  const { data, isLoading } = useQuery({
    queryKey: [
      "dashboard-minicard-lead-transactions",
      JSON.stringify(initialFilters),
    ],
    queryFn: () =>
      apiGetCustomerLeadScannedTransaction({
        join: ["customerUser"],
        filter: [...initialFilters],
      }),
  });

  const total = data?.data?.data?.length || 0;

  const totalPaymentComingToday = data?.data?.data?.filter((d) => {
    const createdAt = dayjs(d.createdAt);
    const startOfToday = dayjs().startOf("day");
    const endOfToday = dayjs().endOf("day");

    return createdAt.isBetween(startOfToday, endOfToday, null, "[]");
  });

  const handleNavigate = () => {
    navigate(ROUTES.ADMIN.CUSTOMER_LEAD.BLOCKCHAIN_PAYMENT_REQUESTS.LIST);
  };

  return (
    <MiniInfoCard
      loading={isLoading}
      navigate={handleNavigate}
      cardProps={cardProps}
      data={{
        icon: <TbZoomMoney />,
        color: magenta[6],
        desc: (
          <FormattedMessage
            id="common.totalX"
            values={{ x: messages["common.blockchainPayments"] as string }}
          />
        ),
        title: total,
        rightMenu: {
          key: "new",
          data: {
            data: totalPaymentComingToday?.length || 0,
            duration: messages["common.today"] as string,
          },
        },
      }}
    />
  );
}
